import { ColorIcon, ColorIconColor } from '@/components/generic/icon/ColorIcon';
import { IroName, IroNameProps } from './IroName';
import { IroNegativeImpactCard_IroFragment } from '@/graphql/generated';
import { ThumbDownIcon } from '@/components/icons';

export function IroNegativeImpactCard({
  iro,
  language,
}: {
  iro: IroNegativeImpactCard_IroFragment;
} & IroNameProps) {
  return (
    <div className="bg-white p-2 rounded-lg border border-gray-100 shadow-sm">
      <div className="flex items-center gap-4">
        <div className="bg-green-50 rounded-lg p-1 text-green-900 shrink-0 w-8 h-8 flex items-center justify-center">
          <ColorIcon color={ColorIconColor.Red} icon={<ThumbDownIcon />} />
        </div>
        <IroName {...{ iro, language }} />
      </div>
    </div>
  );
}
